import React, { useMemo } from 'react';
import { AIcon } from '../../atoms/AIcon/index';
import { AIconSize, type AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ALabel, ALabelSize } from '../../atoms/ALabel/index';
import * as Styled from './MTabControl.styles';
import { type MTabControlProps, MTabControlAlignment } from './MTabControl.types';
import clsx from 'clsx';

const COMPONENT_NAME = 'm-web-ui-kit-MTabControl';
const TEST_ID = 'web-ui-kit-MTabControl';

function MTabControl({
  label,
  description,
  showIcon = false,
  aIcon = {},
  alignment = MTabControlAlignment.Left,
  active = false,
  onClick,
  className,
  ...rest
}: MTabControlProps) {
  const _aIcon = useMemo<AIconProps>(
    () => ({
      ...aIcon,
      icon: aIcon.icon ?? '',
      size: aIcon.size ?? AIconSize.L,
      className: clsx(aIcon.className, active ? 'a-icon-branded' : 'a-icon-muted'),
    }),
    [aIcon, active]
  );

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      $active={active}
      $alignment={alignment}
      onClick={onClick}
      className={className}
      type="button"
      role="tab"
      aria-selected={active}
      {...rest}
    >
      {showIcon && _aIcon.icon && (
        <Styled.IconWrapper>
          <AIcon {..._aIcon} />
        </Styled.IconWrapper>
      )}
      <Styled.TextBlock $alignment={alignment} $active={active}>
        <ALabel text={label} size={ALabelSize.M} className="m-tab-control-label" />
        {description && <ALabel text={description} size={ALabelSize.XS} className="m-tab-control-description" />}
      </Styled.TextBlock>
    </Styled.Wrapper>
  );
}

export { MTabControl, MTabControlAlignment, TEST_ID as M_TAB_CONTROL_TEST_ID };
